export const isTimsTermsCondition = false;
